<template>
  <div class="rtcPlayer">
    <video ref="webRtcPlayerBox" class='webRtcPlayerBox' controls autoplay style="text-align:left;">
      Your browser is too old which doesn't support HTML5 video.
    </video>
  </div>
</template>

<script>
  // let webrtcPlayer = null;
  export default {
    name: 'rtcPlayer',
    data() {
      return {
        timer: null,
        index: null,
        videoUrl: null,
      };
    },
    props: ['error', 'hasaudio'],
    mounted() {
      // this.$refs.webRtcPlayerBox.addEventListener('click', function(event) {
      //   event.preventDefault(); // 阻止点击事件默认行为（例如暂停）
      // });
      // this.play("",0);
    },
    watch: {
      // videoUrl(newData, oldData){
      //   this.$nextTick(() =>{
      //     console.log("初始化时的地址为: " + this.videoUrl)
      //     console.log(this._webrtcPlayers);
      //     // if (this._webrtcPlayers[this._uid] != null) {
      //     //     this._webrtcPlayers[this._uid].release();
      //     //     this._webrtcPlayers[this._uid] = null;
      //     // }
      //     this.play(newData);
      //   })
      // },
      // immediate:true,
    },
    methods: {
      play(url, index) {
        if (url == null || url == "") {
          return false;
        }
        this.index = index;
        if (this._webrtcPlayers[index] != null) {
          this._webrtcPlayers[index].close();
          this._webrtcPlayers[index] = null;
          console.log("我被释放了", index);
        }
        this._webrtcPlayers[index] = new ZLMRTCClient.Endpoint({
          element: this.$refs.webRtcPlayerBox, // video 标签
          debug: false, // 是否打印日志
          zlmsdpUrl: url, //流地址
          simulecast: false,
          useCamera: false,
          audioEnable: false,
          videoEnable: true,
          recvOnly: true,
          usedatachannel: false,
        })

        let webrtcPlayer = this._webrtcPlayers[index];

        webrtcPlayer.on(ZLMRTCClient.Events.WEBRTC_ICE_CANDIDATE_ERROR, (e) => { // ICE 协商出错
          // console.error('ICE 协商出错')
          // this.eventcallbacK("ICE ERROR", "ICE 协商出错")
        });

        webrtcPlayer.on(ZLMRTCClient.Events.WEBRTC_ON_REMOTE_STREAMS, (e) => { //获取到了远端流，可以播放
          // console.log('播放成功',e.streams)
          // this.eventcallbacK("playing", "播放成功")
        });

        webrtcPlayer.on(ZLMRTCClient.Events.WEBRTC_OFFER_ANWSER_EXCHANGE_FAILED, (e) => { // offer anwser 交换失败
          console.error('offer anwser 交换失败', e)
          this.eventcallbacK("OFFER ANSWER ERROR ", "offer anwser 交换失败")
          if (e.code == -400 && e.msg == "流不存在") {
            console.log("流不存在")
            this.timer = setTimeout(() => {
              webrtcPlayer.close();
              this.play(url)
            }, 100)

          }
        });

        webrtcPlayer.on(ZLMRTCClient.Events.WEBRTC_ON_LOCAL_STREAM, (s) => { // 获取到了本地流

          // document.getElementById('selfVideo').srcObject=s;
          // this.eventcallbacK("LOCAL STREAM", "获取到了本地流")
        });

      },
      pause() {
        if (this._webrtcPlayers[this.index] != null) {
          this._webrtcPlayers[this.index].close();
          this._webrtcPlayers[this.index] = null;
        }

      },
      eventcallbacK(type, message) {
        console.log("player 事件回调")
        console.log(type)
        console.log(message)
      }
    },
    destroyed() {
      clearTimeout(this.timer);
    },
  }
</script>

<style>
  .LodingTitle {
    min-width: 70px;
  }

  .rtcPlayer {
    width: 100%;
    height: 100%;
  }

  .webRtcPlayerBox {
    width: 100%;
    height: 100%;
    background-color: #000;
  }

  /* 隐藏logo */
  /* .iconqingxiLOGO {
        display: none !important;
    } */
</style>



// WEBPACK FOOTER //
// src/components/common/rtcPlayer.vue